function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M456.73,606.5l-301.08.03c-28.84,0-56.2-5.03-78.83-22.34-36.41-27.84-41.19-64.67-41.2-109.07l-.02-274.39c0-28.25.41-63.14,6.8-88.94,8.07-32.59,31.59-57.83,63.7-67.66,24.82-7.59,56.63-8.07,83.86-8.06l242.06.06c26.12,0,56.75,1.18,80.26,9.6,28.03,10.05,48.96,32.15,57.4,60.72,7.85,26.56,8.39,61.19,8.39,90.23l-.04,281.41c0,14.82-.7,27.99-2.89,42.2-6.19,40.23-35.38,72.07-74.93,81.57-14.29,3.43-27.64,4.63-43.48,4.63Z"
});

var SvgIterm2 = function SvgIterm2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 613.56 630.71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M562.6,603.72c-32.18,22.72-69.02,26.98-108.38,26.98l-291.51.02c-40.6,0-77.17-3.62-110.85-26.62C10.92,576.13.07,529.41.06,481.16L0,194.67c0-20.7.66-39.96,2.49-60.17,1.61-17.87,4.92-34.67,11.26-51.42C25.18,52.89,47.31,29.16,76.7,15.77,105.81,2.51,142.28,0,174.9,0l262.8.03c27.94,0,58.57,2.13,84.79,10.19,37.07,11.38,65.3,38.74,78.4,75.23,5.23,14.56,8.14,29.09,9.7,44.66,2.22,22.19,2.93,43.58,2.93,66.12l.04,282.67c0,49.23-9.23,95.34-50.96,124.81Z",
    style: {
      fill: "#c6d2d5"
    }
  }), _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M475.13,581.05l-46.15,1.08-266.26-.06c-14.08,0-26.63-.52-40.04-3.31-21.43-4.46-40-16.99-50.57-36.23-12.11-22.04-12.01-50.33-12-76.54l.05-261.25c0-23.21.33-44.98,2.59-67.77,1.52-15.32,5.17-30.01,13.79-42.63,11.77-17.21,30.31-26.74,50.77-30.04,17.98-2.9,34.99-3.46,53.57-3.47h248.13c19-.01,36.53.44,54.96,3.07,30.82,4.41,53.64,20.38,62.6,50.62,3.35,11.31,5.23,22.59,5.5,34.52l1.44,63.77-.18,272.34c-.02,35.03-6.61,65.35-37.53,83.88-12.23,7.33-25.82,11.65-40.66,12Z",
    style: {
      fill: "#2d333a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.21,
    y: 118.49,
    width: 65.18,
    height: 142.57,
    style: {
      fill: "#4ea547"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.14,269.17h-16.98s-.15-21.85-.15-21.85c-13.82-1.82-26.6-7.13-36.91-17.59l12.1-14.91c9.35,8.25,19.86,13.69,32.11,14.05,12.36.37,21.76-5.43,20.88-15.38-1.42-16.12-36.87-16.27-51.89-32.47-11.39-12.28-9.61-32.05,3.15-42.62,6.06-5.02,12.74-7.52,20.44-8.99l.28-20.41,16.61.12.11,20.19c12.03,1.45,23,5.81,31.68,14.73l-11.7,14.42c-10.58-9.12-24.25-13.64-37.05-9.1-4.84,1.72-7.82,6.25-8.28,10.5-1.81,16.94,35,15.43,51.93,32.9,7.27,7.5,9.07,17.64,6.85,28.61-2.99,14.78-17.13,24.15-33,25.8l-.18,21.99Z",
    style: {
      fill: "#4ea546"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIterm2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "iterm2.svg";
export { ForwardRef as ReactComponent };